export default {
  tab: {
    _3_months: '3M',
    _6_months: '6M',
    _9_months: '9M',
    this_year: '1Y',
    three_years: '3Y',
    all_time: 'All',
  },
  chartTitle: 'VALUATION CHART',
  avgPlus1Std: 'Average value plus 1 standard deviation',
  avgPlus2Std: 'Average value plus 2 standard deviation',
  avgSub1Std: 'Average value plus 1 standard deviation',
  avgSub2Std: 'Average value plus 2 standard deviation',

  footer: 'Price: x 1,000.',
};
